import React, { useEffect, useState } from 'react'
import { v2_projects, v2_ships } from '../../../../actions/v2/projectAndVessel';
import { v2_ship_owners } from '../../../../actions/v2/masterData';
import DatePicker from 'react-datepicker';

import { encodeBase64UrlJsonPayload } from '../../../../utils';
const SearchFilter = ({ onSearch }) => {
    const [state, setState] = useState({
        project: { name: 'project', value: '', options: [] },
        owner: { name: 'owner', value: '', options: [] },
        builder: { name: 'builder', value: '', options: [] },
        weekEndingSunday: { name: 'weekEndingSunday', value: '' },
    })
    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prev) => ({
            ...prev,
            [name]: {
                ...prev[name],
                value,
            },
        }));
    };

    const handleSubmit = () => {
        // e.preventDefault();
        // Implement search logic here using searchState values
        onSearch(encodeBase64UrlJsonPayload({
            projectId: state.project.value,
            ownerId: state.owner.value,
            weekEndingSunday: state.weekEndingSunday.value,

        }))
    };

    useEffect(() => {
        v2_projects().then((res) => {
            if (res.status) {
                setState((prev) => ({
                    ...prev,
                    project: { ...prev.project, options: res.result },
                }));
            }
        });

        v2_ship_owners().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    owner: {
                        ...prev.owner,
                        options: res.result || [],
                    }
                }));
            }
        });

    }, []);



    useEffect(() => {
        handleSubmit()
    }, [state.project.value, state.owner.value, state.weekEndingSunday.value])


    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body card-body-search">
                        <div
                            className="row gy-12 gx-12 align-items-center"
                        >
                            <div className="row">

                                <div className="form-group col-md-2">
                                    <label htmlFor="inputEmail4" className="col-form-label">
                                        Project
                                    </label>
                                    <select className="form-select"
                                        value={state.project.value}
                                        name={state.project.name}
                                        onChange={handleChange}
                                    >
                                        <option value="">All Projects</option>
                                        {state.project.options.map((item) => (
                                            <option key={item.ID} value={item.ID}>
                                                {item.PROJECT_CODE} - {item.PROJECT_NAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inputEmail4" className="col-form-label">
                                        Owner
                                    </label>
                                    <select className="form-select"
                                        value={state.owner.value}
                                        name={state.owner.name}
                                        onChange={handleChange}
                                    >
                                        <option value="">All Owner</option>

                                        {state.owner.options.map((item) => (
                                            <option key={item.ID} value={item.ID}>
                                                {item.OWNER_NAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inputState" className="col-form-label">
                                        Week Ending Sunday
                                    </label>
                                    <DatePicker
                                        selected={
                                            state.weekEndingSunday.value
                                                ? new Date(state.weekEndingSunday.value)
                                                : null
                                        }
                                        onChange={(date) => {
                                            setState((prev) => ({
                                                ...prev,
                                                weekEndingSunday: {
                                                    ...prev.weekEndingSunday,
                                                    value: date.toISOString().split('T')[0],
                                                },
                                            }));
                                        }}
                                        filterDate={(date) => date.getDay() === 0} // Only allow Sundays
                                        placeholderText="Select a Sunday"
                                        className="form-control"
                                        dateFormat="yyyy-MM-dd"
                                    />
                                </div>

                            </div>
                            {/* <div className="row">
                                <div className="form-group col-md-12">
                                   
                                    <button
                                        type="submit"
                                        style={{
                                            backgroundImage: "linear-gradient(90deg, #6895b4, #265578)"
                                        }}
                                        className="btn btn-primary waves-effect btn-label waves-light"
                                        fdprocessedid="o4l2kzc"
                                    >
                                        <i className="bx bx-cloud-download label-icon" /> Download All
                                        Records
                                    </button>
                                    
                                </div>
                            </div> */}
                        </div>
                    </div>
                    {/* end card body */}
                </div>
                {/* end card */}
            </div>
            {/* end col */}
        </div>

    )
}

export default SearchFilter